import { features } from '@/mocks/categories';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            Why Use VigorBuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            Everything you need to make informed purchasing decisions — all in one trusted resource hub.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="flex flex-col gap-3 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all group"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} w-5 h-5 flex items-center justify-center text-accent-600`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-1.5">
                  {feat.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {feat.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}